// src/images.js

// Import all your images here
import logo from "./logo.png";
import banner1 from "./banner-1.jpg";
import banner2 from "./banner-2.jpg";
import banner3 from "./banner-3.jpg";
import banner4 from "./banner-4.jpg";
import cart from "./cart.svg";
import buying1 from "./buying-1.jpg";
import buying2 from "./buying-2.jpg";
import buying3 from "./buying-3.jpg";
import buying4 from "./buying-4.jpg";
import buying5 from "./buying-5.jpg";
import buying6 from "./buying-6.jpg";
import buying7 from "./buying-7.jpg";
import partner1 from "./partner-1.png";
import partner2 from "./partner-2.png";
import partner3 from "./partner-3.png";
import partner4 from "./partner-4.png";
import partner5 from "./partner-5.png";
import partner6 from "./partner-6.png";
import partner7 from "./partner-7.png";
import partner8 from "./partner-8.png";
import bannerImg5 from "./banner-img-5.jpg";
import bannerImg6 from "./banner-img-6.jpg";
import bannerImg7 from "./banner-img-7.jpg";
import bannerImg8 from "./banner-img-8.jpg";
import shape1 from "./shape-1.png";
import shape2 from "./shape-2.png";
import shape3 from "./shape-3.png";
import shape7 from "./shape-7.png";
import shape8 from "./shape-8.png";
import blog2 from "./blog-2.jpg";
import blog3 from "./blog-3.jpg";
import blog8 from "./blog-8.jpg";
import blog14 from "./blog-14.jpg";
import blog15 from "./blog-15.jpg";
import rightLongArrow from "./right-long-arrow.svg";
import testimonialBg from "./testimonial-bg.jpg";
import testimonial1 from "./testimonial-1.jpg";
import testimonial2 from "./testimonial-2.jpg";
import testimonial3 from "./testimonial-3.jpg";
import testimonial5 from "./testimonial-5.jpg";
import testimonial6 from "./testimonial-6.jpg";
import testimonial7 from "./testimonial-7.jpg";
import testimonial8 from "./testimonial-8.jpg";
import testimonial9 from "./testimonial-9.jpg";
import testimonial10 from "./testimonial-10.jpg";
import about1 from "./about-1.jpg";
import about2 from "./about-2.jpg";
import whyUs from "./why-us.jpg";
import faq from "./faq.jpg";
import financing1 from "./financing-1.jpg";
import financing2 from "./financing-2.jpg";
import calculateImg from "./calculate-img.jpg";
import video from "./video.jpg";
import trast from "./trast.svg";
import stars45 from "./stars-4.5.svg";
import reviewOnBg from "./review-on-bg.jpg";
import google from "./google.svg";
import team3 from "./team-3.jpg";
import team4 from "./team-4.jpg";
import team5 from "./team-5.jpg";
import team6 from "./team-6.jpg";
import creditCard from "./credit-card.png";
import rating from "./dollar.png";
import house from "./market.png";
import graph from "./graph.png";
import imageNotFound from "./image-not-found.png";
import userPlaceholder from "./user.png";
import geniuszReview from "./geniusz-review.png";

// Export them as an object
export const IMAGES = {
  logo,
  banner1,
  banner2,
  banner3,
  banner4,
  cart,
  buying1,
  buying2,
  buying3,
  buying4,
  buying5,
  buying6,
  buying7,
  partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  partner6,
  partner7,
  partner8,
  bannerImg5,
  bannerImg6,
  bannerImg7,
  bannerImg8,
  shape1,
  shape2,
  shape3,
  shape7,
  shape8,
  blog2,
  blog3,
  blog8,
  blog14,
  blog15,
  rightLongArrow,
  testimonialBg,
  testimonial1,
  testimonial2,
  testimonial3,
  testimonial5,
  testimonial6,
  testimonial7,
  testimonial8,
  testimonial9,
  testimonial10,
  about1,
  about2,
  whyUs,
  faq,
  financing1,
  financing2,
  calculateImg,
  video,
  trast,
  stars45,
  reviewOnBg,
  google,
  team3,
  team4,
  team5,
  team6,
  creditCard,
  rating,
  house,
  graph,
  imageNotFound,
  userPlaceholder,
  geniuszReview
};
